export default "data:application/octet-stream;base64,LnBpbi1jb250ZW50LWNhcmQtbGlzdCB7CiAgZGlzcGxheTogJ2ZsZXgnOwogIGdhcDogJzE1cHgnOwp9Cg=="